// extracted by mini-css-extract-plugin
module.exports = {"inner":"coming-soon-modal_inner__v6ptU","inputs":"coming-soon-modal_inputs__K_ryO"};